export default "__VITE_ASSET__Cvdtbnau__"